import React from 'react';
import {Container,Row,Col} from 'react-bootstrap';
import Nav from '../Components/Nav'

export default class Home extends React.Component {
    render(){
      return (
        <Container fluid>
          <Row>
            <Nav />
            <Col>
              <h3 data-testid="title" style={{paddingTop:10, paddingBottom:10}}>Help</h3>
              <p style={{fontWeight:"bold"}}>Sending a Message:</p>
              <p>To send a new message, tap on the new messages tab, and construct a message.</p>
              <ul>
                <li>You will have an option to confirm your message before you hit send.</li>
                <li>Messages will take approx. 15 min to deliver.</li>
                <li>You may submit english or Amharic text.</li>
              </ul>
    
              <p style={{fontWeight:"bold"}}>View Sent Messages:</p>
              <p>You can view sent messages from the sent messages tab.</p>
    
              <p style={{fontWeight:"bold"}}>Managing Contacts:</p>
              <p>- TBD</p>
            
            </Col>
          </Row>
        </Container>
      )
    }
  }